export default function Go_Syntax () {
  return (
    <div>
      <h1>Go_Syntax </h1>
      <p>Go Syntax</p>
    </div>
  );
}